/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Action_View_ClientInputs */

const en_notifications_action_view_client = /** @type {(inputs: Notifications_Action_View_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View client`)
};

const pt_br2_notifications_action_view_client = /** @type {(inputs: Notifications_Action_View_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver cliente`)
};

/**
* | output |
* | --- |
* | "View client" |
*
* @param {Notifications_Action_View_ClientInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_action_view_client = /** @type {((inputs?: Notifications_Action_View_ClientInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Action_View_ClientInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_action_view_client(inputs)
	return pt_br2_notifications_action_view_client(inputs)
});